var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    [
      _c("q-card-main", { staticClass: "gutter-sm" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.exibirEtiqueta,
                expression: "exibirEtiqueta"
              }
            ],
            staticClass: "row"
          },
          [
            _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-0" }, [
              _vm._v(_vm._s(_vm.etiqueta))
            ])
          ]
        ),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [_vm._t("default")], 2)
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 text-right" },
            [
              _c(
                "q-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.indexEdicao === "" &&
                        !_vm.desabilitar &&
                        _vm.indexVisualizacao === "",
                      expression:
                        "indexEdicao === '' && !desabilitar && indexVisualizacao === ''"
                    }
                  ],
                  attrs: { small: "", color: "grey-4" },
                  on: {
                    click: function($event) {
                      _vm.inserirElementoInterno()
                    }
                  }
                },
                [
                  _c("q-tooltip", [_vm._v("Inserir Dados")]),
                  _c("q-icon", {
                    attrs: { name: "fa fa-plus", color: "blue-7", size: "19px" }
                  })
                ],
                1
              ),
              _c(
                "q-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.indexEdicao !== "" &&
                        !_vm.desabilitar &&
                        _vm.indexVisualizacao === "",
                      expression:
                        "indexEdicao !== '' && !desabilitar && indexVisualizacao === ''"
                    }
                  ],
                  attrs: { small: "", color: "grey-4" },
                  on: {
                    click: function($event) {
                      _vm.salvarEdicaoElemento()
                    }
                  }
                },
                [
                  _c("q-tooltip", [_vm._v("Inserir Dados da Edição")]),
                  _c("q-icon", {
                    attrs: { name: "fa fa-save", color: "blue-7", size: "19px" }
                  })
                ],
                1
              ),
              _c(
                "q-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.indexEdicao !== "" || _vm.indexVisualizacao !== "",
                      expression:
                        "(indexEdicao !== '' || indexVisualizacao !== '')"
                    }
                  ],
                  attrs: { small: "", color: "grey-4" },
                  on: {
                    click: function($event) {
                      _vm.cancelarEdicao()
                    }
                  }
                },
                [
                  _c("q-tooltip", [_vm._v("Cancelar")]),
                  _c("q-icon", {
                    attrs: { name: "fa fa-ban", color: "red-7", size: "19px" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("q-progress", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.progresso,
                  expression: "progresso"
                }
              ],
              attrs: { indeterminate: true }
            }),
            _c(
              "table",
              {
                staticClass: "col-xs-12",
                attrs: { cellspacing: "0", cellpadding: "0" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.colunas, function(coluna) {
                        return _c(
                          "th",
                          {
                            key: coluna.id,
                            class: coluna.cabecalhoClasse,
                            attrs: { width: coluna.largura }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(coluna.cabecalhoEtiqueta) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      _c("th", { attrs: { width: "110px" } })
                    ],
                    2
                  )
                ]),
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dados.length == 0,
                            expression: "dados.length == 0"
                          }
                        ]
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "50" }
                          },
                          [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                        )
                      ]
                    ),
                    _vm._l(_vm.dados, function(linha) {
                      return _c(
                        "tr",
                        { key: linha.id },
                        [
                          _vm._l(_vm.colunas, function(coluna) {
                            return _c(
                              "td",
                              {
                                key: coluna.id,
                                class: coluna.conteudoClasse,
                                style: coluna.conteudoEstilo,
                                attrs: { width: coluna.largura }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getPropriedade(coluna, linha)) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          _c(
                            "td",
                            { staticClass: "text-right" },
                            [
                              _vm._l(_vm.operacoes, function(acao) {
                                return _c(
                                  "q-btn",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.acaoVisivel(linha, acao),
                                        expression: "acaoVisivel(linha, acao)"
                                      }
                                    ],
                                    key: acao.tooltip,
                                    attrs: {
                                      round: "",
                                      small: "",
                                      flat: "",
                                      color: acao.cor,
                                      disabled: !_vm.acaoPermissao(linha, acao)
                                    },
                                    on: {
                                      click: function($event) {
                                        acao.clique(linha)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-icon", {
                                      attrs: { name: acao.icone, size: "19px" }
                                    }),
                                    _c(
                                      "q-tooltip",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: acao.tooltip,
                                            expression: "acao.tooltip"
                                          }
                                        ],
                                        attrs: { anchor: "top left" }
                                      },
                                      [_vm._v(" " + _vm._s(acao.tooltip) + " ")]
                                    )
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "q-btn",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.exibirBotaoVisualizacao,
                                      expression: "exibirBotaoVisualizacao"
                                    }
                                  ],
                                  attrs: {
                                    round: "",
                                    small: "",
                                    flat: "",
                                    disable: false
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.visualizarElementoInterno(linha)
                                    }
                                  }
                                },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fa fa-search ",
                                      color: "blue",
                                      size: "19px"
                                    }
                                  }),
                                  _c("q-tooltip", [
                                    _vm._v("Visualizar Elemento")
                                  ])
                                ],
                                1
                              ),
                              _vm.exibirBotaoEdicaoFuncao(linha) &&
                              _vm.exibirBotaoEdicao
                                ? _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        round: "",
                                        small: "",
                                        flat: "",
                                        disable:
                                          !_vm.habilitarEdicao(linha) ||
                                          _vm.desabilitar
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.editarElementoInterno(linha)
                                        }
                                      }
                                    },
                                    [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "fa fa-edit",
                                          color: "orange",
                                          size: "19px"
                                        }
                                      }),
                                      _c("q-tooltip", [
                                        _vm._v("Editar Elemento")
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "q-btn",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.exibirBotaoExclusaoFuncao(linha) &&
                                        _vm.exibirBotaoExclusao,
                                      expression:
                                        "(exibirBotaoExclusaoFuncao(linha)) && (exibirBotaoExclusao)"
                                    }
                                  ],
                                  attrs: {
                                    round: "",
                                    small: "",
                                    flat: "",
                                    disable:
                                      !_vm.habilitarExclusao(linha) ||
                                      _vm.desabilitar
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.confExcluir.clique(linha)
                                    }
                                  }
                                },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fa fa-trash",
                                      color: "red",
                                      size: "19px"
                                    }
                                  }),
                                  _c("q-tooltip", [_vm._v("Excluir da Lista")])
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.exibirMensagemEmBaixoDoGrid,
                expression: "exibirMensagemEmBaixoDoGrid"
              }
            ],
            staticClass: "row"
          },
          [_c("div", [_vm._v(_vm._s(_vm.mensagem))])]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }